export function mapToDLocalLocale(locale: string): string {
	return locale.split('-')[0];
}
